import { atom } from "recoil";

const selectedConversationAtom = atom({
  key: "selectedConversation",
  default: null,
});

export default selectedConversationAtom;
